/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { lazyRoute, lazyNamedRoute } from './lazyRoute';
import { type NavigationRoute } from './navigationRoute';

export const infoPageRoutes: NavigationRoute[] = [
    {
        path: '/faq',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/faq/FAQ')),
    },
    {
        path: '/feedback',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/Feedback')),
    },
    {
        path: '/site-map',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/SiteMap')),
    },
    {
        path: '/subscribe',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/SubscribePage')),
    },
    {
        path: '/use-our-data',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/UseOurData')),
    },
    {
        path: '/whats-new',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/WhatsNew')),
    },
    {
        path: '/unsupported-browser',
        lazy: lazyRoute(() => import('../../src/containers/tertiary/UnsupportedBrowser')),
    },
    {
        path: '/blm-donations-terms-and-conditions',
        lazy: lazyRoute(
            () => import('../../src/containers/tertiary/donation-tacs/DonationTACBLM')
        ),
    },
    {
        path: '/usace-donations-terms-and-conditions',
        lazy: lazyRoute(
            () => import('../../src/containers/tertiary/donation-tacs/DonationTACUSACE')
        ),
    },
    {
        path: '/usfs-donations-terms-and-conditions',
        lazy: lazyRoute(
            () => import('../../src/containers/tertiary/donation-tacs/DonationTACUSFS')
        ),
    },
    {
        path: '/vulnerability-disclosure-policy',
        lazy: lazyRoute(
            () => import('../../src/containers/VulnerabilityDisclosurePolicyPage')
        ),
    },
    {
        path: '/about-us',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/AboutUsPage/AboutUsPage'),
            'AboutUsPage'
        ),
    },
    {
        path: '/accessibility',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/AccessibilityPage/AccessibilityPage'),
            'AccessibilityPage'
        ),
    },
    {
        path: '/get-involved',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/GetInvolvedPage/GetInvolvedPage'),
            'GetInvolvedPage'
        ),
    },
    {
        path: '/government-shutdown-info',
        lazy: lazyNamedRoute(
            () =>
                import('site-kit/src/components/GovernmentShutdownPage/GovernmentShutdownPage'),
            'GovernmentShutdownPage'
        ),
    },
    {
        path: '/media-center',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/MediaCenterPage/MediaCenterPage'),
            'MediaCenterPage'
        ),
    },
    {
        path: '/mobile-app/scanned?',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/MobileAppPage/MobileAppPage'),
            'MobileAppPage'
        ),
    },
    {
        path: '/new-implementations',
        lazy: lazyNamedRoute(
            () =>
                import('site-kit/src/components/NewImplementationsPage/NewImplementationsPage'),
            'NewImplementationsPage'
        ),
    },
    {
        path: '/learnmore/:invType',
        lazy: lazyNamedRoute(
            () =>
                import('site-kit/src/components/NewImplementationsPage/NewInventoryLearnMorePage'),
            'NewInventoryLearnMorePage'
        ),
    },
    {
        path: '/privacy-policy',
        lazy: lazyNamedRoute(
            () => import('site-kit/src/components/PrivacyPolicyPage/PrivacyPolicyPage'),
            'PrivacyPolicyPage'
        ),
    },
    {
        path: '/rules-reservation-policies',
        lazy: lazyNamedRoute(
            () =>
                import('site-kit/src/components/RulesReservationPoliciesPage/RulesReservationPoliciesPage'),
            'RulesReservationPoliciesPage'
        ),
    },
    {
        path: '/reservation-policies',
        lazy: lazyNamedRoute(
            () =>
                import('site-kit/src/components/RulesReservationPoliciesPage/RulesReservationPoliciesPage'),
            'RulesReservationPoliciesPage'
        ),
    },
];

// cSpell: ignore learnmore, tac, tacs, tacblm
